import { CheerzApiDraft } from "@Types/api/draft";
import Draft from "@Types/draft";

export const convertFromApiToDraftsContent = (jsonContent: CheerzApiDraft[]): Draft[] => {
  const drafts = jsonContent.map((draftContent) => {
    return {
      id: draftContent.id,
      product: {
        image: draftContent.product.product_image["2x"],
        name: draftContent.product.name,
        outOfStock: draftContent.product.out_of_stock,
        tag: draftContent.product.tag,
      },
      updatedAt: draftContent.updated_at,
    };
  });
  return drafts;
};
